export default "__VITE_ASSET__Dac5no9q__"